import React from 'react';


const OurCapabilities = () => {
	return (
	  <>
      <div className='w-11/12 lg:w-8/12 lg:px-6 py-16 mx-auto space-y-16'>
            <h1 className='text-4xl font-bold text-center '>Our Capabilities</h1>

            <div className='space-y-6'>
                <div className='space-y-6'>
                    <h4 className='text-[#ff8000] tracking-wide text-lg font-semibold'>NJM Group Capability Statement</h4>
                    <p className='tracking-wide text-base'>
                    The NJM Group is made up of five companies that design and manufacture high-quality steel building and safety products; and provide related delivery and installation services.  From manufacturing and distributing facilities in Heidelberg West, we service a wide range of clients located throughout Australia. The companies, listed below, are complementary and overlap in their provision of services:
                    </p>                                
                </div>
                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-wide text-lg font-semibold'>Work and Experience</h4>
                    <h4 className='tracking-wide text-lg '>NJMs’ work ranges from:</h4>

                    <div className='pl-10'>
                        <ul className='list-disc text-base space-y-2 tracking-wide'>
                            <li>bespoke steel fabrications within commercial office fit-outs and high-quality architectural detailing. </li>
                            <li>station bicycle parking facilities, road safety railings, containment barriers and platform fencing. </li>
                        </ul>
                    </div>
                </div>
                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-wide text-lg font-semibold'>Clients</h4>
                    <h4 className='tracking-wide text-lg '>NJM Group serves a wide range of clients including:</h4>

                    <div className='pl-10'>
                        <ul className='list-disc text-base space-y-2 tracking-wide'>
                            <li>John Holland Contractors (Regional Rail Link Package A; Cardinia and Lynbrook Stations, Nunawading Station, Laverton North Station). </li>
                            <li>Leighton Contractors (Bollards, miscellaneous steel items)</li>
                            <li>Australand (General capital improvements works for property portfolio, bollards and handrails)</li>
                            <li>Wilson Parking (Bollards, car parking products and equipment including card readers, SKIDATA equipment – Australia-wide)</li>
                            <li>Crown Casino (Bollards and parking/safety barriers)</li>
                            <li>Siemens (Sunshine Coast Hospital - Emergency Help Point Bollards)</li>
                            <li>Westfield Shopping Centres (Bollards – Australia-wide)</li>
                            <li>Colliers (Building maintenance services, general capital improvement works)</li>
                            <li>McConnell Dowell (Springvale Train Station –Handrail and Balustrade works )</li>
                        </ul>
                    </div>
                </div>

                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-wide text-lg font-semibold'>Philosophy and Commitment</h4>
                    <h4 className='tracking-wide text-base '>“Service, Quality and Continuous Improvement".</h4>

                    <p>
                        NJM Group is committed to providing quality products and services that consistently meet or exceed our client expectations and industry standards. We strive to improve as an organisation in our processes and hence, in the provision of our products and delivery of services. 
                    </p>
                    <p>
                        Our team will be there from start to finish to deliver the high standard of service on which we have built our reputation.
                    </p>
                </div>

                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-wide text-lg font-semibold'>Compliance</h4>

                    <div className='pl-10'>
                        <ul className='list-disc text-base space-y-2 tracking-wide'>
                            <li>Registered Commercial Building Practitioners: CB-U6782  DB-U34444 MBAV-8367. </li>
                            <li>Building Code 2013 Compliant.</li>
                            <li>NJM Building Contractors is a member of the PICS Consortium. </li>
                            <li>NJM installation team hold current Working with Rail Cards (and have undertaken the relevant Track Training/Protection Awareness course.) including Pegasus Card.</li>
                        </ul>
                    </div>

                    <p>
                        <span className='font-bold'>All our team of onsite installers, carpenters, welders & labourers</span> are prequalified inducted with Pegasus, Australia's leading Contractor OHS/WHS Prequalification system, ensuring that our induction training is compliant to legislation and that the safety message is delivered to all stakeholders (staff, visitors, contractors and suppliers) at the highest possible standard, for Australian Railway Association (ARA) Including Rail Track Safety Awareness for the Vline, A.R.T.C. and Metro Trains Melbourne networks.
                    </p>
                </div>
                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-wide text-lg font-semibold'>Contractor rail construction site track OHS/WHS Prequalification</h4>

                    <p>
                        <span className='italic '>Reducing the ever increasing burden of legislative requirements and information collection, Pegasus Safety aims to assure the total safety compliance of your organisation.  </span> 
                        Cm3 Contractor OHS/WHS Prequalification
                    </p>
                    <p>
                        <span className='font-bold'>Australian Bollards </span>is prequalified with Cm3, Australia's leading Contractor OHS/WHS Prequalification system that demonstrates and maintains our  <span className='font-bold'>Australian Bollards </span> health and safety capability.
                    </p>
                    <p>
                    Cm3 addresses the need for both contractors; and the organisations they conduct work for, to demonstrate contractor health and safety management capabilities.
                    </p>
                </div>

                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-widest text-lg font-semibold'>AS OUR CLIENT</h4>

                    <p>
                        Our Cm3 prequalification helps you to meet your legislative duty of care to ensure that we <span className='font-bold'>Australian Bollards </span>  as your contractor, have processes to safely conduct work along with assisting in managing your contractor’s health and safety requirements.
                    </p>
                </div>

                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-widest text-lg font-semibold'>AS YOUR CONTRACTOR</h4>
                    <p className='font-bold italic'>
                    Demonstrating and maintaining our health and safety capabilities
                    </p>

                    <p>
                        Cm3 assists  <span className='font-bold'>Australian Bollards </span> in obtaining and maintaining OHS/WHS prequalification for our services and health & safety capabilities to you our client.
                    </p>
                    <p>
                    Cm3 is an OHS/WHS prequalification system, developed so that  <span className='font-bold'>Australian Bollards </span> can demonstrate to you our health and safety capabilities to our clients.
                    </p>
                    <p>
                    Cm3 prequalification consists of checking that we  <span className='font-bold'>Australian Bollards </span> have the right insurances as well as a comprehensive assessment of our safety systems.
                    </p>
                    <p>
                    This assessment is completed by OHS/WHS specialists from GreencapNAA - one of Australia's leading specialists in health and safety risk management.
                    </p>
                </div>

                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-widest text-lg font-semibold italic'>DEMONSTRATE OUR SAFETY CAPABILITIES</h4>
                    <p className=''>
                    Cm3 prequalification let us show our  <span className='font-bold'>Australian Bollards </span> current and future clients how we manage safety – helping our clients meet their duty of care to make sure we are working safely.
                    </p>
                </div>
                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-widest text-lg font-semibold italic'>IMPROVE OUR SAFETY MANAGEMENT</h4>
                    <p className=''>
                    By <span className='font-bold'>Australian Bollards </span>  achieving Cm3 prequalification, helps us review our current safety practices, identify any gaps and improve our safety management processes.
                    </p>
                </div>
                <div className='space-y-3'>
                    <h4 className='text-[#ff8000] tracking-widest text-lg font-semibold italic'>REDUCED COMPLIANCE COSTS</h4>
                    <p className=''>
                    For our <span className='font-bold'>Australian Bollards </span>  clients that are registered on Cm3, they can accept our Cm3 prequalification automatically. This eliminates the need for our clients to undertake separate prequalification’s, reducing the time and cost of compliance and letting you get on with business.
                    </p>
                </div>


            </div>
    	</div>
      </>
	);
 };
 
 export default OurCapabilities;